// extracted by mini-css-extract-plugin
export var closeButton = "_e4-1";
export var closeX = "_e4-3";
export var container = "_e4-0";
export var image = "_e4-2";